import React from 'react';
import './styles/App.css';
import './styles/HomeScreen.css';

import 'bootstrap/dist/css/bootstrap.css';

import {
    Route,
    useParams,
    Routes,
    BrowserRouter
  } from "react-router-dom";

import NavBar from './components/Navbar';
import HomeScreen from './screens/HomeScreen';
import ProductsScreen from './screens/ProductsScreen';
import ProfileScreen from './screens/ProfilePage';
import LoginPage from './screens/LoginPage';
import RegisterPage from './screens/RegisterPage';
import CartScreen from './screens/cart';
import SingleProductPage from './screens/SingleProductScreen';
import GalleryScreen from './screens/GalleryScreen';
import ChatScreen from './screens/chatScreen';
import OrderScreen from './screens/OrderScreen';
import Allusers from './screens/allusers';
import AddPaymentPage from './screens/addpayment';
import Addproductpage from './screens/addproduct';
class App extends React.Component
{
    constructor() {
        super()
    }

    render()
    {
        return (
            <div className='body'>       
                <NavBar/>
                <BrowserRouter>
                  <Routes>
                    <Route exact path="/" element={<HomeScreen/>}/>
                    <Route path="/products" element={<ProductsScreen/>}/>
                    <Route path="/Login" element={<LoginPage/>}/>
                    <Route path="/Register" element={<RegisterPage/>}/>
                    <Route path="/profile" element={<ProfileScreen/>}/>
                    <Route path="/SingleProduct" element={<SingleProductPage/>}/>
                    <Route path="/cart" element={<CartScreen/>}/>
                    <Route path="/gallery" element={<GalleryScreen/>}/>
                    <Route path="/chat" element={<ChatScreen/>}/>
                    <Route path="/order" element={<OrderScreen/>}/>
                    <Route path="/allusers" element={<Allusers/>}/>
                    <Route path="/addpayment" element={<AddPaymentPage/>}/>
                    <Route path="/addproduct" element={<Addproductpage/>}/>              
                  </Routes>
                </BrowserRouter>
              </div>
        );
    }
}

export default App;